import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {TransformerInterface} from "./transformerInterface";
import {CommandDTO} from "../domain/dtos/command.dto";
import {OverrideEntityLockCommand} from "../commands/override-entity-lock.command";
import {OverrideEntityLockPayload} from "../commands/override-entity-lock.command";

/**
 * Serialises a OverrideEntityLockCommand into the backend command DTO.
 *
 * A dedicated transformer is REQUIRED, not a nicety. Without one the generic
 * command→DTO fallback runs, and that fallback demands a change-tracked proxy
 * as the payload — a lock command carries a plain object, so it throws
 * "The payload of the command must be a proxified object". The throw happens
 * OUTSIDE the CommandBus's try block, so it wedges the bus for the rest of the
 * session rather than failing the one command.
 *
 * Measured on com.open2done.local 2026-09-06: clicking "Bearbeiten" on a
 * Linkview produced exactly that, and no unit test saw it because they all stub
 * the bus.
 */
@injectable()
@transformer({
    source: OverrideEntityLockCommand,
    target: `dto`
})
export class OverrideEntityLockCommandToDtoTransformer implements TransformerInterface<CommandDTO<OverrideEntityLockPayload>, OverrideEntityLockCommand> {

    public async transform(command: OverrideEntityLockCommand): Promise<CommandDTO<OverrideEntityLockPayload>> {
        return <CommandDTO<OverrideEntityLockPayload>>{
            uid: command.uid,
            name: command.name,
            mainEntityClass: command.mainEntityClass,
            mainEntityUid: command.mainEntityUid,
            payload: command.payload,
        };
    }
}
